<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid>
      <cv-row>
        <cv-column :sm="2" :md="4" :lg="8">
          <data-valida etichetta="Dalla Data"
                       v-model="parametri.dalla_data"
                       messaggio_non_valido="Data iniziale non valida" />
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="8">
          <data-valida etichetta="Alla Data"
                       v-model="parametri.alla_data"
                       messaggio_non_valido="Data finale non valida" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-combo-box label="" title="Ditta"
                        value="" :auto-filter="true"
                        v-model="modello"
                        :options="ditte"></cv-combo-box>
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <BottonieraRicerche v-on:filtra-premuto="$emit('bottone-premuto')"
                        v-on:pdf-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import BottonieraRicerche from "@/components/BottonieraRicerche";

export default {
  name: "RicercaBilancio",
  components: { BottonieraRicerche },
  data: function() {
    return {
      parametri: {
        dalla_data: "",
        alla_data: ""
      },
      modello: "",
      ditte: [
        {
          value: "1",
          label: "Gianni Rossi s.r.l",
          name: "1",
        },
        {
          value: "2",
          label: "Mario Verdi s.r.l",
          name: "2",
        },
        {
          value: "3",
          label: "Paolo Bianchi s.r.l",
          name: "3",
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>